export const searchRoutesMutationKey = ({
  future,
  offset,
  limit,
  sort_by,
  sort_direction,
}: {
  future: boolean;
  offset?: number;
  limit?: number;
  sort_by?: string;
  sort_direction?: string;
}) => {
  return [`vehicle_routes`, future, offset, limit, sort_by, sort_direction];
};

export const getLastUnfinishedRouteMutationKey = () => [`last_unfinished_route`];
